import ForecastDataVisualizer from './ForecastDataVisualizer';

export default ForecastDataVisualizer;
